import { gql } from 'graphql-request'

export const SEARCH_ORDERS = gql`
  query searchOrders($input: OrderSearchInput!) {
    searchOrders(input: $input) {
      orders {
        id
        orderId
      }
    }
  }
`

export const SEARCH_USER_ORDERS = gql`
  query searchOrders($input: OrderSearchInput!) {
    searchOrders(input: $input) {
      totalCount
      page
      pageSize
      orders {
        id
        createdAt
        totalPriceCents
        orderId
        state
        receiptViews
        device
        requiresMobileVerification
        requiresTravelDocuments

        brand {
          userEditOrderEnabled
        }

        user {
          id
          firstName
          lastName
          email
          phoneNumber
          mobileVerificationEligible
          mobileVerified
        }

        legs {
          legIndex
          pickup
          uberPickup
          pickupReadyTime
          pickupCloseTime
          shipRoute {
            origin {
              address1
              address2
              city
              state
              zip5
              countryCode
              companyName
              attentionName
              cruise
            }

            destination {
              address1
              address2
              city
              state
              zip5
              countryCode
              companyName
              attentionName
              cruise
            }
          }
        }

        shipments {
          id
          updatedAt
          carrierTrackingId
          trackingId
          shipDate
          arrivalDate
          state

          carrierServiceLevel {
            shortName
            systemName
            displayName
            carrier {
              systemName
              displayName
            }
          }

          product {
            ... on LabelProduct {
              _type
              id
              displayName
              name
              weight
              productLine {
                id
                displayName
              }
            }
          }

          packaging {
            name
          }

          leg {
            id
            legIndex
          }

          cruiseSession {
            cruiseLine
            shipName
            cabin
            reservationNumber
            embarkationPort
            disembarkationPort
            embarkationDate
            disembarkationDate
          }

          traveler {
            id
            name
            email
            phone
          }
        }

        transactions {
          transactionId
          type
          value
          state
          payerName
          payerEmail
          paymentMethod {
            ... on BraintreePaymentMethod {
              cardBrand
              expirationDate
              last4
            }
            ... on ClubBillingPaymentMethod {
              facility {
                id
                name
              }
              accountNumber
            }
          }
        }
      }
    }
  }
`
